import { Box, Text } from '@chakra-ui/react';
import PhoneInputWithCountry from 'react-phone-number-input';
import { isValidPhoneNumber, type Country } from 'react-phone-number-input';
import './PhoneInput.css';

export interface PhoneValidationResult {
  isValid: boolean;
  error?: string;
  formattedNumber?: string;
}

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  onCountryChange?: (countryCode: string) => void;
  onValidationChange?: (validation: PhoneValidationResult) => void;
  placeholder?: string;
  error?: string;
  defaultCountry?: string;
  id?: string;
  name?: string;
  autoComplete?: string;
}

export const PhoneInput = ({
  value,
  onChange,
  onCountryChange,
  onValidationChange,
  placeholder = 'Phone Number',
  error,
  defaultCountry = 'US',
  id,
  name,
  autoComplete,
}: PhoneInputProps) => {
  const handleChange = (phoneValue: string | undefined) => {
    const newValue = phoneValue || '';
    onChange(newValue);
    
    if (onValidationChange) {
      if (newValue) {
        const isValid = isValidPhoneNumber(newValue);
        onValidationChange({
          isValid,
          formattedNumber: newValue,
          error: isValid ? undefined : 'Invalid phone number',
        });
      } else {
        onValidationChange({
          isValid: false,
          error: 'Phone number is required',
        });
      }
    }
  };

  const handleCountryChange = (countryCode: string | undefined) => {
    if (onCountryChange && countryCode) {
      onCountryChange(countryCode);
    }
  };

  return (
    <Box w="full" position="relative">
      <PhoneInputWithCountry
        international
        defaultCountry={defaultCountry as Country}
        value={value || undefined}
        onChange={handleChange}
        onCountryChange={handleCountryChange}
        placeholder={placeholder}
        className={`phone-input-wrapper ${error ? 'phone-input-error' : ''}`}
        numberInputProps={{
          className: 'w-full',
          id: id || undefined,
          name: name || undefined,
          autoComplete: autoComplete || 'tel',
        }}
        countrySelectProps={{
          className: 'relative',
          id: id ? `${id}-country` : undefined,
          name: name ? `${name}-country` : undefined,
        }}
      />
      {error && (
        <Text as="span" display="block" mt="1" fontSize="xs" color="volyx.error" fontFamily="body" pl="1">
          {error}
        </Text>
      )}
    </Box>
  );
};
